<!-- Stammdaten change modal overlay -->
<div class="modal-backdrop">
  <div class="modal-panel">

    <!-- Header -->
    <div class="modal-header">
      <h2>{{ 'stammdatenModal.title' | t }}</h2>
      <button
        class="modal-close-btn"
        type="button"
        data-track="master_data_close" (click)="onClose()"
        [attr.aria-label]="'modalCommon.closeAria' | t">
        &times;
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <section class="current-data" [attr.aria-label]="'stammdatenModal.currentData' | t">
        <h3>{{ 'stammdatenModal.currentData' | t }}</h3>
        <dl>
          <dt>{{ 'stammdatenModal.name' | t }}</dt>
          <dd>{{ currentName() || ('common.notAvailable' | t) }}</dd>
          <dt>{{ 'stammdatenModal.address' | t }}</dt>
          <dd>{{ currentAddress() || ('common.notAvailable' | t) }}</dd>
        </dl>
      </section>
      <p class="modal-intro">
        {{ 'stammdatenModal.intro' | t }}
      </p>

      @if (showDevHelper) {
        <div class="dev-helper-box" role="note">
          <div class="dev-helper-head">{{ 'modalCommon.devDataTitle' | t }}</div>
          <div class="dev-helper-body">{{ 'stammdatenModal.devBody' | t }}</div>
          <button type="button" class="btn-dev-fill" (click)="insertTestData()">
            {{ 'modalCommon.insertTestData' | t }}
          </button>
        </div>
      }

      <form class="stammdaten-form" novalidate (ngSubmit)="onSubmit()">
        <div class="change-row">
          <label class="change-toggle">
            <input
              type="checkbox"
              [ngModel]="changeName()"
              (ngModelChange)="changeName.set($event)"
              name="changeName" />
            <span>{{ 'stammdatenModal.name' | t }}</span>
          </label>
          @if (changeName()) {
            <input
              type="text"
              [placeholder]="'stammdatenModal.namePlaceholder' | t"
              [ngModel]="fullName()"
              (ngModelChange)="fullName.set($event); nameEdited = true"
              name="fullName"
              autocomplete="name" />
          }
        </div>

        <div class="change-row">
          <label class="change-toggle">
            <input
              type="checkbox"
              [ngModel]="changeAddress()"
              (ngModelChange)="changeAddress.set($event)"
              name="changeAddress" />
            <span>{{ 'stammdatenModal.address' | t }}</span>
          </label>
          @if (changeAddress()) {
            <textarea
              rows="3"
              [placeholder]="'stammdatenModal.addressPlaceholder' | t"
              [ngModel]="address()"
              (ngModelChange)="address.set($event); addressEdited = true"
              name="address"
              autocomplete="street-address"></textarea>
          }
        </div>

        <div class="change-row">
          <label class="change-toggle">
            <input
              type="checkbox"
              [ngModel]="changeIban()"
              (ngModelChange)="changeIban.set($event)"
              name="changeIban" />
            <span>{{ 'stammdatenModal.bank' | t }}</span>
          </label>
          @if (changeIban()) {
            <input
              type="text"
              [placeholder]="'stammdatenModal.ibanPlaceholder' | t"
              [value]="ibanFormatted()"
              (input)="onIbanInput($event)"
              name="iban"
              autocomplete="off" />
            @if (submitAttempted() && !ibanValid()) {
              <div class="field-error">{{ 'stammdatenModal.ibanError' | t }}</div>
            }
          }
        </div>

        <div class="change-row">
          <label for="stammdaten-email" class="field-label">{{ 'stammdatenModal.email' | t }}</label>
          <input
            id="stammdaten-email"
            type="email"
            [placeholder]="'stammdatenModal.emailPlaceholder' | t"
            [ngModel]="email()"
            (ngModelChange)="email.set($event)"
            name="email"
            autocomplete="email" />
        </div>

        <div class="change-row">
          <label for="stammdaten-telefon" class="field-label">{{ 'stammdatenModal.phone' | t }}</label>
          <input
            id="stammdaten-telefon"
            type="tel"
            [placeholder]="'stammdatenModal.phonePlaceholder' | t"
            [ngModel]="telefon()"
            (ngModelChange)="telefon.set($event)"
            name="telefon"
            autocomplete="tel" />
        </div>
        <label class="change-toggle">
          <input type="checkbox" name="confirmedCorrect" [ngModel]="confirmedCorrect()"
            (ngModelChange)="confirmedCorrect.set($event)" required />
          <span>{{ 'stammdatenModal.confirmCorrect' | t }}</span>
        </label>
      </form>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-cancel" data-track="master_data_close" (click)="onClose()">{{ 'common.cancel' | t }}</button>
      <button type="button" class="btn-submit" data-track="master_data_submit" [disabled]="!isValid()" (click)="onSubmit()">{{ 'common.submit' | t }}</button>
    </div>

  </div>
</div>
